module.exports = __webpack_public_path__ + "img/un.4a86eab8.svg";